import { useState } from 'react';

/**
 * G500Lite遷移メニューの状態管理用カスタムフック
 */
export const useStateG500LiteMenu = () => {
	const [anchorElG500LiteMenu, setAnchorElG500LiteMenu] = useState<null | HTMLElement>(null); // ポップアップメニューの開閉状態を管理
	const openG500LiteMenu = Boolean(anchorElG500LiteMenu);

	const handleOpenG500LiteMenu = (event: React.MouseEvent<HTMLElement>) => {
		setAnchorElG500LiteMenu(event.currentTarget);
	};

	const handleCloseG500LiteMenu = () => {
		setAnchorElG500LiteMenu(null);
	};

	return {
		anchorElG500LiteMenu,
		openG500LiteMenu,
		handleOpenG500LiteMenu,
		handleCloseG500LiteMenu,
	};
};
